import React from 'react';
import { Info } from 'lucide-react';

export function ProductSizeSelector({
  sizes, available_sizes, selectedSize, setSelectedSize,
  requestedSize, sizeRequestSent, sizeRequestLoading,
  submitSizeRequest, handleSoldOutSizeClick, setRequestedSize,
}) {
  if (!sizes?.length) return null;

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs uppercase tracking-[0.2em] text-[#0A0A0A] font-semibold font-work">Select Size</p>
        {available_sizes && (
          <p className="text-[10px] text-[#999999] font-work">Greyed sizes are sold out — tap to request</p>
        )}
      </div>

      <div className="flex flex-wrap gap-2">
        {sizes.map(s => {
          const available = !available_sizes || available_sizes.includes(s);
          const isSelected = selectedSize === s;
          const isRequested = requestedSize === s;
          return (
            <button
              key={s}
              onClick={() => available
                ? setSelectedSize(s === selectedSize ? '' : s)
                : handleSoldOutSizeClick(s)
              }
              className={`px-3 h-10 text-xs font-work border transition-all duration-150 relative
                ${!available
                  ? isRequested
                    ? 'border-[#D4AF37] text-[#D4AF37] bg-[#D4AF37]/5 line-through'
                    : 'border-[#E5E5E5] text-[#CCCCCC] hover:border-[#D4AF37]/50 hover:text-[#BBBBBB] cursor-pointer line-through'
                  : isSelected
                    ? 'bg-[#0A0A0A] text-white border-[#0A0A0A]'
                    : 'border-[#E5E5E5] text-[#0A0A0A] hover:border-[#D4AF37]'
                }`}
              data-testid={`size-${s}`}
            >
              {s}
              {!available && (
                <span className="block text-[9px] leading-none mt-0.5" style={{ textDecoration: 'none' }}>
                  {isRequested ? 'requested' : 'sold out'}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Size Request Panel */}
      {requestedSize && (
        <div className="mt-4 border border-[#D4AF37]/40 bg-[#D4AF37]/5 p-4" data-testid="size-request-panel">
          {sizeRequestSent ? (
            <div className="text-center py-2">
              <p className="text-sm font-semibold text-[#0A0A0A] font-work mb-1">Request Received</p>
              <p className="text-xs text-[#555555] font-work">
                Our personal shopper will be in touch regarding <span className="font-semibold">{requestedSize}</span>. Availability and pricing will be confirmed once sourced.
              </p>
            </div>
          ) : (
            <>
              <div className="flex items-start gap-2 mb-3">
                <Info size={13} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-xs font-semibold text-[#0A0A0A] font-work mb-1">
                    Requesting size <span className="text-[#D4AF37]">{requestedSize}</span>
                  </p>
                  <p className="text-[11px] text-[#666666] font-work leading-relaxed">
                    This size is currently sold out at our primary source. Our personal shopper will locate it from an alternative boutique — <span className="font-semibold text-[#0A0A0A]">please note the price may vary</span> depending on where the item is sourced.
                  </p>
                </div>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={submitSizeRequest}
                  disabled={sizeRequestLoading}
                  className="flex-1 bg-[#D4AF37] text-[#0A0A0A] py-2.5 text-xs uppercase tracking-widest font-semibold font-work hover:bg-[#C49B2E] transition-colors disabled:opacity-60"
                  data-testid="submit-size-request-btn"
                >
                  {sizeRequestLoading ? 'Sending...' : 'Send Request to Personal Shopper'}
                </button>
                <button
                  onClick={() => setRequestedSize('')}
                  className="border border-[#E5E5E5] px-3 text-xs text-[#999999] font-work hover:border-[#D4AF37]"
                >
                  Cancel
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
